module.exports = __webpack_public_path__ + "img/svg/timer.e6bb508c5b9caf687fa4ada153b1e824.svg";